export default "__VITE_ASSET__DyAP$_OJ__"